import React from 'react'
import { ChatMode } from '@/constants/chat'

interface ChatBoxFooterProps {
  mode: ChatMode
  chatData?: any
}

const ChatBoxFooter: React.FC<ChatBoxFooterProps> = ({ mode, chatData }) => {
  if (mode === ChatMode.NEGOTIATION_HISTORY) {
    return (
      <div className='p-3 border-t border-gray-100 bg-gray-50/80 rounded-b-xl'>
        <div className='flex items-center justify-center gap-2'>
          <div className='w-2 h-2 bg-green-400 rounded-full animate-pulse'></div>
          <div className='text-xs text-gray-500 font-medium'>
            Negotiation Messages • View Only
          </div>
        </div>
      </div>
    )
  }

  if (mode === ChatMode.PREVIOUS_CHAT && chatData) {
    return (
      <div className='p-3 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 rounded-b-xl'>
        <div className='mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-500'>
          <span>
            <span className='font-medium text-gray-700'>Temperature:</span>{' '}
            {chatData.temperature}
          </span>
          <span>
            <span className='font-medium text-gray-700'>Max Tokens:</span>{' '}
            {chatData.max_tokens}
          </span>
          <span>
            <span className='font-medium text-gray-700'>History Limit:</span>{' '}
            {chatData.history_limit}
          </span>
          <span>
            <span className='font-medium text-gray-700'>LLM:</span>{' '}
            {chatData.llm_model}
          </span>
        </div>
      </div>
    )
  }

  return null
}

export default ChatBoxFooter
